import root from 'window-or-global';

import all from './all.env';

const envSpecificVariables = __SERVER__
  ? // eslint-disable-next-line @typescript-eslint/no-require-imports, import-x/no-dynamic-require
    require(`./environments/${process.env.ENVIRONMENT}`)
  : root.environment || {};

const defaultFeatures = Object.freeze(
  Object.assign({}, all.features, envSpecificVariables.features || {}),
);

const env = Object.assign({}, all, envSpecificVariables);

// removing `features` prop from the exported object
// as it should be only available through the `getFeatures` redux selector
delete env.features;

root.defaultFeatures = defaultFeatures;

export default env;
